import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import {
  AIRTABLE_URL_TECHNICIAN,
  AIRTABLE_HEADERS
} from "./constants"; // ✅ Yeh import zaroori hai

export default function TechnicianHome() {
  const navigate = useNavigate();
  const location = useLocation();

  const technicianPhone =
    location.state?.technicianPhone || localStorage.getItem("technicianPhone");

  if (location.state?.technicianPhone) {
    localStorage.setItem("technicianPhone", location.state.technicianPhone);
  }

  const storedName = localStorage.getItem("technicianName");
  const [technicianName, setTechnicianName] = useState(storedName || null);
  const [duty, setDuty] = useState(null);

 const buttonStyle = {
  marginBottom: 10,
  padding: "12px 15px",
  backgroundColor: "#f2f2f2",
  border: "1px solid #ccc",
  borderRadius: 5,
  cursor: "pointer",
  fontSize: "16px",
  display: "block",     // 👈 ek line me ayega
  width: "100%",        // 👈 full screen width le lega
  boxSizing: "border-box",
};

  const logoutStyle = {
    ...buttonStyle,
    backgroundColor: "red",
    color: "white",
    width: "100%",
  };

  // ✅ useCallback lagaya hai
  const updateDutyStatus = useCallback(async (newStatus) => {
    try {
      setDuty(newStatus);
      localStorage.setItem("technicianDuty", newStatus); // ✅ Save to local

      const res = await fetch(
        `${AIRTABLE_URL_TECHNICIAN}?filterByFormula=${encodeURIComponent(`{phone} = '${technicianPhone}'`)}`,
        { headers: AIRTABLE_HEADERS }
      );

      const json = await res.json();
      const recordId = json.records?.[0]?.id;
      if (!recordId) return;

      await fetch(AIRTABLE_URL_TECHNICIAN, {
        method: "PATCH",
        headers: AIRTABLE_HEADERS,
        body: JSON.stringify({
          records: [{ id: recordId, fields: { duty: newStatus } }],
        }),
      });

      console.log("✅ Duty updated to", newStatus);
    } catch (err) {
      console.error("❌ Error updating duty", err);
    }
  }, [technicianPhone]); // ✅ ab stable function hai

  useEffect(() => {
    const storedDuty = localStorage.getItem("technicianDuty");
    if (storedDuty) {
      setDuty(storedDuty); // Fast load from cache
    }
  }, []);

  // ✅ Fetch Technician Details
  useEffect(() => {
    const nameInStorage = localStorage.getItem("technicianName");
    const dutyInStorage = localStorage.getItem("technicianDuty");

    if (nameInStorage && dutyInStorage) return;

    const fetchTechnicianData = async () => {
      try {
        const res = await fetch(
          `${AIRTABLE_URL_TECHNICIAN}?filterByFormula=${encodeURIComponent(`{phone} = '${technicianPhone}'`)}`,
          { headers: AIRTABLE_HEADERS }
        );

        const json = await res.json();
        const record = json.records?.[0]?.fields;

        if (record) {
          setTechnicianName(record.name || "Unknown");
          localStorage.setItem("technicianName", record.name || "Unknown");

          localStorage.setItem("technicianStatus", record.status || "under_review");

          if (record.duty && record.duty !== dutyInStorage) {
            setDuty(record.duty);
            localStorage.setItem("technicianDuty", record.duty);
          }
        }
      } catch (err) {
        console.error("❌ Error loading technician data", err);
      }
    };

    fetchTechnicianData();
  }, [technicianPhone]);

  // ✅ Auto-duty ON after 7 AM
  useEffect(() => {
    if (duty === null) return;

    const now = new Date();
    const hour = now.getHours();
    const today = now.toISOString().split("T")[0];
    const lastAutoDuty = localStorage.getItem("lastAutoDuty");

    if (hour >= 7 && duty === "off" && lastAutoDuty !== today) {
      updateDutyStatus("on");
      localStorage.setItem("lastAutoDuty", today);
    }
  }, [duty, updateDutyStatus]);

  const handleDutyToggle = () => {
    if (duty === "on") {
      const confirmOff = window.confirm("Are you sure you want to turn off duty?");
      if (!confirmOff) return;
    }
    updateDutyStatus(duty === "on" ? "off" : "on");
  };

  if (technicianName === null) {
    return <p>Loading your profile...</p>;
  }

  if (duty === null) {
    return <p>Loading your duty status...</p>;
  }

  return (
    <div style={{ padding: 20, position: "relative", width: "100vw", maxWidth: "100%", boxSizing: "border-box" }}>
      <h2>Welcome, {technicianName} 👋</h2>

      {/* ✅ Duty Toggle Button */}
      <div style={{ marginBottom: 20 }}>
        <button
          onClick={handleDutyToggle}
          style={{
            display: "block",           // 👈 ek line me full row
            width: "100%",
            padding: "12px 15px",
            backgroundColor: duty === "on" ? "green" : "gray",
            color: "white",
            border: "none",
            borderRadius: 5,
            cursor: "pointer",
          }}
        >
          {duty === "on" ? "🟢 Duty On" : "⚫ Duty Off"}
        </button>
      </div>

      {/* ✅ Buttons Section */}
      <div>
        <button onClick={() => navigate("/technician-dashboard")} style={buttonStyle}>
          🧾 Assigned Services
        </button>
        <button onClick={() => navigate("/my-earnings")} style={buttonStyle}>
          💰 My Earnings
        </button>
        <button onClick={() => navigate("/history")} style={buttonStyle}>
          📜 My History
        </button>
        <button onClick={() => navigate("/technician-rating")} style={buttonStyle}>
          ⭐ My Rating
        </button>
        <button onClick={() => navigate("/technician-complaints")} style={buttonStyle}>
          🛠️ Customer Complaint
        </button>
        <button onClick={() => navigate("/technician-issue")} style={buttonStyle}>
          🧯 My Issues
        </button>
      </div>

      {/* 🔒 Logout */}
      <button
        onClick={() => {
          localStorage.clear();
          navigate("/technician-login");
        }}
        style={logoutStyle}
      >
        🔒 Logout
      </button>
    </div>
  );
}
